// useSession.js
import { useRef, useEffect } from "react";
import axios from "axios";
import { BASE_URL } from "../constant/api";

export const useSession = () => {
  const sessionChecked = useRef(false);
  const hasGeneratedSession = useRef(false);

  useEffect(() => {
    const handleSession = async () => {
      const token = localStorage.getItem("token");
      let sessionId = localStorage.getItem("sessionid");

      // If token exists, no need to handle sessionId
      if (token) {
        localStorage.removeItem("sessionid");
        sessionId = null;
        return; // Exit early if token exists
      }

      // Prevent checking the session multiple times
      if (sessionChecked.current) return;
      sessionChecked.current = true;

      try {
        // If sessionId doesn't exist, generate a new one
        if (!sessionId) {
          if (!hasGeneratedSession.current) {
            const response = await axios.get(`${BASE_URL}/accounts/webcreate-sessionid/`);
            sessionId = response.data.sessionid;
            localStorage.setItem("sessionid", sessionId);
            hasGeneratedSession.current = true; // Mark that the session ID was generated
          }
        } else {
          // If sessionId exists, validate it
          await axios.get(`${BASE_URL}/accounts/webcreate-sessionid/`, {
            headers: { 'Session-Id': sessionId },
          });
        }
      } catch (error) {
        console.error("Error handling session ID:", error);
        return; // Exit if session handling fails
      }
    };

    handleSession();
  }, []);
};

